import styles from "./Gallery.module.css";
import ArtworkCard from "../ArtworkCard/ArtworkCard";

export default function Gallery({ items }) {
  if (!items || items.length === 0) {
    return <p style={{ marginTop: "20px" }}>Nenhum resultado encontrado.</p>;
  }

  return (
    <div className={styles.grid}>
      {items.map((artwork) => (
        <ArtworkCard key={artwork.objectID} artwork={artwork} />
      ))}
    </div>
  );
}
